module.exports = __webpack_public_path__ + "img/model_22_ug.d8f5b384.jpg";